import { Hash } from "lucide-react";

export default function RoomList({ rooms, room, onPick }) {
  return (
    <nav className="flex lg:flex-col gap-2 overflow-x-auto pb-1 lg:pb-0" data-testid="community-room-list">
      {rooms.map((r) => {
        const active = r.id === room;
        return (
          <button key={r.id} onClick={() => onPick(r.id)} data-testid={`community-room-${r.id}`} aria-pressed={active}
            className={`shrink-0 text-left px-3 py-2.5 border transition-colors min-h-[44px] ${active ? "border-[#FFD600] bg-[#141414]" : "border-[#262626] hover:border-white"}`}>
            <div className={`text-sm font-semibold inline-flex items-center gap-1.5 whitespace-nowrap ${active ? "text-[#FFD600]" : ""}`}>
              <Hash size={13} /> {r.label}
            </div>
            <div className="hidden lg:block text-[11px] text-muted-foreground mt-0.5">{r.desc}</div>
          </button>
        );
      })}
    </nav>
  );
}
